module.exports = __webpack_public_path__ + "img/archive-icon.9f65b537.svg";